import {FC} from 'react';

type UICardProps = {
  children: any;
  style?: string;
}

const UICard: FC<UICardProps> = ({children, style}) => {
  return (
    <div className={`rounded-md md:shadow-big-card w-full h-full bg-white py-3 md:py-4 px-2 ${style}`}>
      {children}
    </div>
  );
};

export default UICard;
